import type { Product } from '@noths/polaris-design-system-ooux-interfaces';

import type { ProductPriceDiscount } from '../ProductPrice/ProductPrice';

/**
 * Works out whether a product is discounted and by how much.
 *
 * The OOUX `Product` never stores whether a product is on sale, nor the size of
 * the discount, so components derive both by comparing `price` with
 * `originalPrice`. A product is discounted only when `originalPrice` is present
 * and genuinely higher, so bad data (an equal or lower "original") renders as an
 * ordinary price rather than as a 0% saving.
 *
 * The percentage is rounded to the nearest whole number, matching how discounts
 * are quoted everywhere else on the site. The size of the saving in money is not
 * returned, because the card quotes the percentage alone.
 */
export const getDiscount = ({
  originalPrice,
  price,
}: Product): ProductPriceDiscount | undefined => {
  if (originalPrice === undefined || originalPrice <= price) {
    return undefined;
  }

  return {
    originalPrice,
    percentage: Math.round(((originalPrice - price) / originalPrice) * 100),
  };
};
